import styled from 'styled-components';

export const TopBarSC = styled.div`
  display: flex;
  flex-direction: row;
  height: 88px;
  padding-left: 20px;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    color: #333d6c;
    font-weight: 600;

    &:hover,
    &:focus {
      color: #333d6c;
      text-decoration: none;
      opacity: 0.8;
    }

    img {
      margin-right: 8px;
    }
  }
`;

export const ChatRowSC = styled.div`
  display: flex;
  flex: 1;
  border-top: 2px solid #fff;

  .col-chat {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .col-detail {
    display: flex;
    flex-direction: column;
    width: 430px;
  }

  .unsubscribe-button-container {
    margin-top: 20px;
    margin-right: 20px;
    text-align: right;
  }
`;
